/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import {relayWrap} from '../../box-utils/ParentBox.react.js';

import {FormattedNumber, FormattedDate, FormattedMessage, IntlShape} from 'react-intl';
import Error from '../system/Error.react.js';
import EmptyContent from '../system/EmptyContent.react';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import MoreLink from '../../box-utils/MoreLink.react';
import MerkMagnitude from './MerkMagnitude.react';
import PanelColumns from '../system/PanelColumns.react';
import './Merk.scss';
import MerkParent from './Merk';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

class MerkFinancial extends MerkParent {

    static handlerName = "merk-financial";

    computeRow(merk, financial, idx) {
        let economic = {};
        let basic = {};

        if (this.props.isPreview) {
            economic = {
                x0: 9000000,
                f2_1_5: 9000,
                f3_6: 900000,
                CASH_FLOW: 9000,
                f1: 900000,
                year: (new Date().getFullYear() - 1)
            };
			basic = {
				name: 'Firma s.r.o.',
				link: 'https://www.merk.cz/search/detail/cz-5574617/',
				status: {
					id: 1
				},
				magnitude: {
					id: 110,
					lower_bound_val: 50,
					upper_bound_val: 80,
				}
			};
        } else {
            basic = merk.basic;
            if (financial) {
                let finArray = financial[basic.regno];
                if (finArray) {
                    economic = finArray[finArray.length - 1];
                }
            }
        }

        let percAddedValue = 0;
        if (economic.x0 > 0) {
            percAddedValue = economic.f3_6 / economic.x0;
        }
        if (percAddedValue < 0) {
            percAddedValue = 0;
        }

        let percProfit = 0;
        if (economic.f2_1_5 > 0) {
            percProfit = economic.f2_1_5 / economic.x0;
        }
        if (percProfit < 0) {
            percProfit = 0;
        }

        let output = [];

        let hasSomeEconomicData = false;

        output.push(
            <tr key="1"><td className="wrap wholeRow" colSpan="3"><strong className="dativeryValue">{basic.name}</strong> (<MoreLink link={basic.link || ""} service="Merk" />)</td></tr>
        );
        if (economic.year && economic.year < (new Date().getFullYear() - 4)) {
            output.push(<tr key="9-year-warning"><td className="wholeRow" colSpan="3" style={{color: 'red'}}><FormattedMessage defaultMessage="Information is older than 5 years." id="merk.5yearWarning" /></td></tr>);
        }

		output.push(<tr key="2-status"><td><FormattedMessage defaultMessage="Status" id="merk.status" />:</td><td className="r">{this.getCompanyStatus(basic)}</td><td></td></tr>);

        if (economic.x0 || (basic.turnover && basic.turnover.text)) {
            output.push(<tr key="3"><td><FormattedMessage defaultMessage="Revenue" id="merk.revenue" />:</td><td className="r"><span className="dativeryValue">{economic && economic.x0 ? <span><FormattedNumber value={economic.x0} />&nbsp;<FormattedMessage defaultMessage="thou." id="merk.thousand" />&nbsp;Kč</span> : basic.turnover.text}</span></td><td></td></tr>);
            hasSomeEconomicData = true;
        }
        if (economic.f2_1_5) {
            output.push(<tr key="4"><td><FormattedMessage defaultMessage="Profit" id="merk.profit" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.f2_1_5} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="merk.thousand" />&nbsp;Kč</td>{percProfit > 0 ? <td className="r"><small>(<span className="dativeryValue"><FormattedNumber style="percent" value={percProfit} /></span>)</small></td> : <td></td>}</tr>);
            hasSomeEconomicData = true;
        }
        if (economic.f3_6) {
            output.push(<tr key="5"><td><FormattedMessage defaultMessage="Value added" id="merk.valueAdded" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.f3_6} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="merk.thousand" />&nbsp;Kč</td>{percAddedValue > 0 ? <td className="r"><small>(<span className="dativeryValue"><FormattedNumber style="percent" value={percAddedValue} /></span>)</small></td> : <td></td>}</tr>);
            hasSomeEconomicData = true;
        }
        if (economic.f1) {
            output.push(<tr key="6"><td><FormattedMessage defaultMessage="Assets" id="merk.assets" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.f1} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="merk.thousand" />&nbsp;Kč</td><td></td></tr>);
            hasSomeEconomicData = true;
        }
        if (economic.CASH_FLOW) {
            output.push(<tr key="7"><td><FormattedMessage defaultMessage="Cash flow" id="merk.cashFlow" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.CASH_FLOW} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="merk.thousand" />&nbsp;Kč</td><td></td></tr>);
            hasSomeEconomicData = true;
        }
        if (basic.magnitude && basic.magnitude.id && basic.magnitude.id !== 0) {
            output.push(<tr key="8"><td><FormattedMessage defaultMessage="Employees" id="merk.employees" />:</td><td className="r"><MerkMagnitude data={basic.magnitude.enum ? basic.magnitude.enum : basic.magnitude} /></td><td></td></tr>);
        }
        if (economic.year) {
            output.push(<tr key="9"><td className="wholeRow" colSpan="3"><small>(<FormattedMessage defaultMessage="for year" id="merk.forYear" /> <span className="dativeryValue">{economic.year}</span>)</small></td></tr>);
        }

        if (hasSomeEconomicData) {
			if (merk.datum_zaniku) {
				// put the termination date before econonmic data
				output.splice(1, 0, <tr key="2"><td className="wholeRow" colSpan="3"><strong style={{color: 'red'}}><FormattedMessage defaultMessage="Termination date" id="merk.closedDate" /> <FormattedDate value={merk.datum_zaniku} /></strong></td></tr>);
			}
		}
		else {
            output.push(<tr key="0"><td className="wholeRow" colSpan="3"><FormattedMessage defaultMessage="No economic data" id="merk.noEconomicData" /></td></tr>);
			if (merk.datum_zaniku && basic.estab_date) {
				output.push(<tr key="2"><td className="wholeRow" colSpan="3" style={{color: 'green'}}><strong><FormattedMessage defaultMessage="Established" id="merk.establishedDateShort" /> <FormattedDate value={basic.estab_date} /></strong> - <strong style={{color: 'red'}}><FormattedMessage defaultMessage="Terminated" id="merk.closedDateShort" /> <FormattedDate value={merk.datum_zaniku} /></strong></td></tr>);
			}
			else {
				if (basic.estab_date) {
					output.push(<tr key="3"><td className="wholeRow" colSpan="3" style={{color: 'green'}}><strong><FormattedMessage defaultMessage="Established date" id="merk.establishedDate" /> <FormattedDate value={basic.estab_date} /></strong></td></tr>);
				}
				if (merk.datum_zaniku) {
					output.push(<tr key="2"><td className="wholeRow" colSpan="3"><strong style={{color: 'red'}}><FormattedMessage defaultMessage="Termination date" id="merk.closedDate" /> <FormattedDate value={merk.datum_zaniku} /></strong></td></tr>);
				}
			}
        }

        return (
			<div key={idx}>
				<table className="table-spaced-columns company-table">
					<tbody>{output}</tbody>
				</table>
			</div>
        );
    }

    render() {
        try {
            let {addon} = this.props.viewWithData;
            let financialAddon = {};

            if (addon) {
                addon = safeJSONparse(addon);
                //console.log(addon);
                let list;

                if (addon["merk"] && Array.isArray(addon["merk"]) && addon["merk"].length > 0 && addon['merk-financial']) {
                    list = addon["merk"];
                    financialAddon = addon['merk-financial'];
                } else if (this.props.isPreview) {
                    list = [{}];
                } else {
                    return (
                        <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                            <EmptyContent />
                        </BoxDecorator>
                    );
                }

                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
						<PanelColumns small>
							{list.map((merk, idx) => this.computeRow(merk, financialAddon, idx))}
						</PanelColumns>
                    </BoxDecorator>
                );
            }

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <span>?</span>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(MerkFinancial);
